import React, { FC } from 'react';
import { Box } from '@mui/material';
import UserRegister from '../components/LoginScreenComponents/UserRegister';

const Register: FC = () => {
  return (
    <Box
      sx={{
        height: '100%',
        minHeight: '100vh',
        width: '100vw',
        textAlign: 'left',
      }}>
      <Box
        sx={{
          height: '100%',
          minHeight: '100vh',
          width: '100vw',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        <Box sx={{ paddingY: '10vh' }}>
          <UserRegister />
        </Box>
      </Box>
    </Box>
  );
};

export default Register;
